<div style="display: flex; flex-direction: row; height: 100%">
    <!--Nav Menu-->
    <div *ngIf="userType !== 1" class="displaySideMenu"
        style="display: flex; flex-direction: column; flex: .3; overflow: scroll;min-width:330px;">
        <menu></menu>
    </div>
    <div style="display: flex; flex-direction: column; flex: 1; overflow: auto">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" [scale]=".80" class="tylKendoPdf">
            <!--Student Header-->
            <div class="flex-header">
                <student-header [showYearSelector]="true" [pageTitle]="'Student Summary'"></student-header>
            </div>
            <!--Card Container-->
            <div class="flex-content">
                <div style="display: flex; flex-direction: row; margin-bottom: 5px; min-height: 35px;margin-left: 5px;margin-right: 5px;"
                    class="print-padding">
                    <!-- Check In/Check Out -->
                    <div *ngIf="enableCheckInOut" style="justify-content: flex-start;">
                        <button mat-stroked-button (click)="checkInOutButtonClick(selectedStudent.Id)"><span
                            translate>Check In / Check Out</span></button>
                    </div>

                    <!-- Absent Notice -->
                    <div *ngIf="enableAbsentNotice" style="justify-content: flex-start;padding-left: 10px;">
                        <button mat-stroked-button (click)="absentNoticeButtonClick(selectedStudent.Id)"><span
                            translate>Absent Notice</span></button>
                    </div>

                    <!-- Settings -->
                    <div style="display: flex; flex: 1; justify-content: flex-end;">
                        <button style="background-color: #FFA500; color: white;" mat-button (click)="settingsClick()"><span
                            translate>Settings</span></button>
                    </div>
                </div>
                <!--Event Notification Row Parent And Student-->
                <div style="display: flex; flex-direction: column; flex: none;"
                    *ngIf="(userType == 2 || userType == 3) && (eFormHeadLinePermission || v10)">
                    <!-- Required eForms Event Notification -->
                    <div *ngIf="requiredEFormAvailable > 0 && !defaultAcademicYear" class="eventExclamationContainer">
                        <div style="display: flex; flex-direction: row; flex: 1;">
                            <div style="display: flex; flex-direction: row;padding-left: 10px">
                                <img class="notificationBell" src="./assets/images/red exclamation.png">
                            </div>
                            <div style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 10px"
                                translate>
                                <span translate>Required e-Forms have not been
                                    submitted</span><span>&nbsp;({{requiredEFormAvailable}})</span><a
                                    style="padding-left: 10px" (click)="eventViewClick('requiredEForms')"
                                    translate>View</a>
                            </div>
                        </div>
                    </div>
                    <!-- Optional eForms Event Notification -->
                    <div *ngIf="optionalEFormAvailable > 0 && (unmarkedOptionalEFormsEvents || !v10) && !defaultAcademicYear && (recentOptionalEFormEvents && recentOptionalEFormEvents.Count || v10)"
                        class="eventAlertContainer">
                        <div style="display: flex; flex-direction: row; flex: 1;">
                            <div style="display: flex; flex-direction: row;">
                                <img class="notificationBell" src="./assets/images/notification_bell.png">
                            </div>
                            <div style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 5px"
                                translate>
                                <span translate>New optional e-Forms are available</span><a style="padding-left: 10px"
                                    (click)="eventViewClick('optionalEForms')" translate>View</a>
                            </div>
                            <div
                                style="display: flex; flex-direction: row; flex: .2; justify-content: flex-end; align-items: center; padding-right: 10px">
                                <div style="cursor: pointer;" (click)="markEventsAsSeen('OptionalEForms')">X</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display: flex; flex-direction: column; flex: none;"
                    *ngIf="(userType != 1 && !v10) || (v10 && userType == 2)">
                    <!-- Course Requests Event Notification -->
                    <div *ngIf="hasPrivilege('Course Requests')" class="eventAlertContainer">
                        <div style="display: flex; flex-direction: row; flex: 1;">
                            <div style="display: flex; flex-direction: row;">
                                <img class="notificationBell" src="./assets/images/notification_bell.png">
                            </div>
                            <div
                                style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 5px">
                                <span>{{'Course Requests may now be entered' | translate}}</span> <a style="padding-left: 10px"
                                    (click)="eventViewClick('courseRequests')" translate>View</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Student Documents Notification -->
                <div *ngIf="!v10 && studentDocuments && studentDocuments.length > 0" class="eventAlertContainer">
                    <div style="display: flex; flex-direction: row; flex: 1">
                        <div style="display: flex; flex-direction: row;">
                            <img class="notificationBell" src="./assets/images/notification_bell.png">
                        </div>
                        <div
                            style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 5px">
                            <span translate style="padding-right: 5px;">New documents published in the last seven days</span>({{studentDocuments.length}})
                            <a *ngIf="attendancelatterStudentDocuments" style="padding-left: 10px"
                                (click)="eventViewClick('studentDocumentAttLetters')" translate>Attendance Letters</a>
                            <a *ngIf="behaviorlatterStudentDocuments" style="padding-left: 10px"
                                (click)="eventViewClick('studentDocumentBehaviorLetters')" translate>Behavior Letters</a>
                            <a style="padding-left: 10px" (click)="eventViewClick('studentDocument')" translate>View All</a>
                        </div>
                        <div style="display: flex; flex-direction: row; flex: .2; justify-content: flex-end; align-items: center; padding-right: 10px">
                           <div style="cursor: pointer;" (click)="markEventsAsSeen('StudentDocument')">X</div>
                        </div>
                    </div>
                </div>

                <!--Event Notification Row Parent Only-->
                <div style="display: flex; flex-direction: column; flex: none;" *ngIf="userType == 2">
                    <!-- Online Registration Event Notification -->
                    <div *ngIf="hasPrivilege('Online Registration') && displayORHeadline"
                        class="eventExclamationContainer">
                        <div style="display: flex; flex-direction: row; flex: 1;">
                            <div style="display: flex; flex-direction: row;padding-left: 10px">
                                <img class="notificationBell" src="./assets/images/red exclamation.png">
                            </div>
                            <div
                                style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 10px">
                                <span *ngIf="onlineRegistrationStatus.indexOf('Online Registration must be completed for') > -1 && !v10">
                                    {{'Online Registration must be completed for' | translate}}</span>&nbsp;
                                <span
                                    *ngIf="onlineRegistrationStatus.indexOf('Online Registration must be completed for') > -1 && !v10">{{onlineRegistrationStatus | slice:onlineRegistrationStatus.indexOf('for') + 3 :onlineRegistrationStatus.length}}</span>
                                <span
                                    *ngIf="onlineRegistrationStatus.indexOf('Online Registration must be completed for') == -1 && !v10">{{onlineRegistrationStatus | translate}}</span>
                                <span *ngIf="v10">{{onlineRegistrationStatus | translate}} {{requiredORYear}}</span>
                                <a style="padding-left: 10px" (click)="eventViewClick('onlineRegistration')"
                                    translate>View</a>
                            </div>
                        </div>
                    </div>
                    <!-- Discipline Event Notification -->
                    <div *ngIf="recentDisciplineEvents">
                        <div *ngIf="hasPrivilege('Discipline') && recentDisciplineEvents.Count > 0"
                            class="eventAlertContainer">
                            <div style="display: flex; flex-direction: row; flex: 1">
                                <div style="display: flex; flex-direction: row;">
                                    <img class="notificationBell" src="./assets/images/notification_bell.png">
                                </div>
                                <div
                                    style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 5px">
                                    <span translate style="padding-right: 5px;">Behavior events in the last seven
                                        days</span>({{recentDisciplineEvents.Count}}
                                    )<a style="padding-left: 10px" (click)="eventViewClick('discipline')"
                                        translate>View</a>
                                </div>
                                <div
                                    style="display: flex; flex-direction: row; flex: .2; justify-content: flex-end; align-items: center; padding-right: 10px">
                                    <div style="cursor: pointer;" (click)="markEventsAsSeen('Discipline')">X</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Behavior Letter Notification -->
                    <div *ngIf="v10 && recentBehaviorLetters">
                        <div *ngIf="hasPrivilege('Discipline') && recentBehaviorLetters.Count > 0"
                            class="eventAlertContainer">
                            <div style="display: flex; flex-direction: row; flex: 1">
                                <div style="display: flex; flex-direction: row;">
                                    <img class="notificationBell" src="./assets/images/notification_bell.png">
                                </div>
                                <div
                                    style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 5px">
                                    <span translate style="padding-right: 5px;">Behavior letters in the last seven
                                        days ({{recentBehaviorLetters.Count}})</span><a style="padding-left: 10px" (click)="eventViewClick('behaviorLetter')"
                                        translate>View</a>
                                </div>
                                <div
                                    style="display: flex; flex-direction: row; flex: .2; justify-content: flex-end; align-items: center; padding-right: 10px">
                                    <div style="cursor: pointer;" (click)="markEventsAsSeen('BehaviorLetter')">X</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Health Event Notification -->
                    <div *ngIf="recentHealthEvents">
                        <div *ngIf="hasPrivilege('Health') && recentHealthEvents.Count > 0" class="eventAlertContainer">
                            <div style="display: flex; flex-direction: row; flex: 1;">
                                <div style="display: flex; flex-direction: row;">
                                    <img class="notificationBell" src="./assets/images/notification_bell.png">
                                </div>
                                <div
                                    style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 5px">
                                    <span translate style="padding-right: 5px" translate>Health visits in the last seven
                                        days</span>({{recentHealthEvents.Count}}
                                    )<a style="padding-left: 10px" (click)="eventViewClick('health')" translate>View</a>
                                </div>
                                <div
                                    style="display: flex; flex-direction: row; flex: .2; justify-content: flex-end; align-items: center; padding-right: 10px">
                                    <div style="cursor: pointer;" (click)="markEventsAsSeen('Health')">X</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                 <!-- Behavior Letter Notification -->
                 <div *ngIf="v10 && userType == 1" >
                    <div *ngIf="displayBehaviorLetterHeadline"
                        class="eventAlertContainer">
                        <div style="display: flex; flex-direction: row; flex: 1">
                            <div style="display: flex; flex-direction: row;">
                                <img class="notificationBell" src="./assets/images/notification_bell.png">
                            </div>
                            <div
                                style="display: flex; flex-direction: row; flex: 1; justify-content: flex-start; align-items: center; padding-left: 5px">
                                <span translate style="padding-right: 5px;">Behavior letters in the last seven
                                    days ({{recentBehaviorLetters.Count}})</span><a style="padding-left: 10px" (click)="eventViewClick('behaviorLetter')"
                                    translate>View</a>
                            </div>
                            <div
                                style="display: flex; flex-direction: row; flex: .2; justify-content: flex-end; align-items: center; padding-right: 10px">
                                <div style="cursor: pointer;" (click)="onCloseBehaviorLetterNotification();">X</div>
                            </div>
                        </div>
                    </div>
                </div>
                <app-card-container style="display: flex"></app-card-container>
            </div>
        </tyl-kendo-pdf-export>
    </div>
</div>